/* eslint-disable jira/filename-case */
import { getStaticFallbackContext } from './static-fallback-context.tsx';

export function getSsrStatus(): 'static' | 'modern' | 'client' {
	if (__SERVER__) {
		if (getStaticFallbackContext()) {
			return 'static';
		}
		return 'modern';
	}

	return 'client';
}
